import styled, { css } from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: 100%;
	background: url('/image/login/login-colored-bg.png') no-repeat center center / cover;
	position: relative;

	color: ${({ theme }) => theme.colors.revised.dark_blue};

	${({ theme }) => theme.common.flexCenter};

	/* & * {
		font-family: Pretendard;
	} */
`;

export const Inner = styled.div`
	width: 1000px;
	height: 560px;

	${({ theme }) => theme.common.flexCenter};
	align-items: stretch;
	gap: 130px;
`;

export const LeftBox = styled.div`
	width: 380px;
	flex: 0 0 380px;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const Logo = styled.div`
	width: 100%;
	height: 187px;
	object-fit: cover;
`;

export const LeftInfo = styled.div`
	width: 100%;
	color: ${({ theme }) => theme.colors.gray.gray_white};

	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const InfoText = styled.p`
	${({ theme }) => theme.revised_typo.typo_16m};

	& > span {
		${({ theme }) => theme.revised_typo.typo_16b};
	}
`;

export const EmailText = styled.p`
	${({ theme }) => theme.revised_typo.typo_16b};
`;

export const WhiteBorder = styled.div`
	width: 100%;
	height: 0;
	border-bottom: 1px solid ${({ theme }) => theme.colors.gray.gray_white};
	opacity: 0.6;
`;

export const RightBox = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
`;

export const Form = styled.div`
	width: 100%;
	padding: 52px 60px 60px;
	flex-grow: 1;

	background-color: ${({ theme }) => theme.colors.gray.gray_white};

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 30px;
`;

export const FormTitle = styled.h3`
	width: 100%;

	${({ theme }) => theme.revised_typo.head};
	text-align: left;
`;

export const FormInner = styled.div`
	width: 100%;
	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 16px;
`;

export const RememberBox = styled.div<{ checked: boolean }>`
	width: 100%;

	user-select: none;

	& > label {
		color: ${({ theme }) => theme.colors.revised.dark_blue};
		${({ theme }) => theme.revised_typo.typo_14m};
	}

	${({ checked, theme }) =>
		checked
			? css`
					& svg {
						fill: ${theme.colors.revised.point};
					}
			  `
			: css`
					& svg {
						fill: ${theme.colors.revised.dark_blue};
					}
			  `}
`;

export const IconWrapper = styled.span`
	width: 14px;
	height: 16px;

	${({ theme }) => theme.common.flexCenter};

	& > svg {
		fill: ${({ theme }) => theme.colors.revised.point};
	}
`;

export const ButtonContainer = styled.div`
	width: 100%;

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 4px;

	& > a {
		width: 100%;
	}
`;

export const Header = styled.div`
	width: 100%;
	padding: 37.5px 40px;
	position: absolute;
	top: 0;
	left: 0;

	${({ theme }) => theme.common.flexStart};
	align-items: stretch;
	gap: 12px;
`;

export const WhiteVerticalBorder = styled.div`
	width: 0;
	height: 100%;
	border-left: 1px solid ${({ theme }) => theme.colors.gray.gray_white};
	opacity: 0.3;
`;

export const LogoBox = styled.div`
	width: max-content;
	height: 23px;
	object-fit: contain;

	& > svg {
		height: 100%;
	}
`;
